import { authorize, getRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function getZoneGroupsAPI(zoneId) {
  const url = `${AWS_API_URL}/2n/zones/${encodeURIComponent(zoneId)}/groups`;
  return getRequest(url, await authorize());
}

